/** Per-browser conveniences only (e.g. last selected kommune). Never required for correctness. */
const LAST_KOMMUNE = "sv.lastKommune";

export interface KommuneSelection {
  orgId: string;
  nr: string;
}

export function readLastKommune(): KommuneSelection | null {
  try {
    const raw = window.localStorage.getItem(LAST_KOMMUNE);
    if (!raw) return null;
    const v: unknown = JSON.parse(raw);
    if (typeof v === "object" && v !== null && "orgId" in v && "nr" in v) {
      const { orgId, nr } = v as Record<string, unknown>;
      if (typeof orgId === "string" && typeof nr === "string") return { orgId, nr };
    }
  } catch {
    // Storage unavailable (private mode, blocked site data): fall back to defaults.
  }
  return null;
}

export function writeLastKommune(sel: KommuneSelection): void {
  try {
    window.localStorage.setItem(LAST_KOMMUNE, JSON.stringify(sel));
  } catch {
    // Ignore: this is only a convenience.
  }
}
